// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3QgmZ","bigColWidth":"Table_bigColWidth__1G1f2","biggerColWidth":"Table_biggerColWidth__2ZPr8","row":"Table_row__1FDVO","col":"Table_col__U_N_l"};